<!-- This page is displayed when the user is registered but the account is pending approval using vuetify -->
<template>
    <v-slide-x-transition mode="out-in">
        <v-container
            v-if="showComponent"
            style="max-width: 1200px"
        >
            <CardTitle
                :title="$t('registrationPending.title')"
                :link="{ href: '/login', text: $t('resetRequest.backToLogin') }"
            />
            <v-card class="pa-5 mt-5">
                <v-card-text>
                    <template v-if="fromEmailVerification">
                        <v-row>
                            <v-col>
                                <v-card-text>
                                    <p>{{ $t("registrationPending.emailVerifiedContent.paragraph1") }}</p>
                                    <p>{{ $t("registrationPending.emailVerifiedContent.paragraph2") }}</p>
                                    <p>{{ $t("registrationPending.emailVerifiedContent.contactInfo") }}</p>
                                    <p>{{ $t("registrationPending.emailVerifiedContent.thankYou") }}</p>
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <v-row>
                            <v-col>
                                <v-card-text>
                                    <p>{{ $t("registrationPending.description.paragraph1") }}</p>
                                    <p>{{ $t("registrationPending.description.paragraph2") }}</p>
                                    <ul style="padding-left: 3rem">
                                        <li
                                            v-for="(item, index) in emailItems"
                                            :key="index"
                                        >
                                            {{ item }}
                                        </li>
                                    </ul>

                                    <p>{{ $t("registrationPending.description.contactInfo") }}</p>
                                    <p>{{ $t("registrationPending.description.thankYou") }}</p>
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </template>

                    <v-row class="d-flex flex-row justify-space-around mt-5 pt-5">
                        <TextLink
                            :link="{ href: '/policy/terms', text: $t('register.termsAndConditionsLink') }"
                        />
                        <TextLink :link="{ href: '/policy/privacy', text: $t('register.privacyPolicyLink') }"/>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>
    </v-slide-x-transition>
</template>

<script>
import CardTitle from "@/components/registration/CardTitle.vue";
import TextLink from "@/components/registration/TextLink.vue";

export default {
    name: "RegistrationPending",
    components: {
        CardTitle,
        TextLink,
    },
    computed: {
        emailItems() {
            const locale = this.$i18n.locale;
            return Object.values(this.$i18n.messages[locale].registrationPending.description.emailDetails);
        },
        fromEmailVerification() {
            return this.$route.query.mode === "verifyEmail";
        },
    },
    data() {
        return {
            showComponent: false,
        };
    },
    mounted() {
        this.showComponent = true;
    },
};
</script>
<style scoped>
p, li {
    font-size: 1rem;
}
</style>
